import { Statistic } from "antd";
import { CountDownProps, StatisticProps } from "./type";
const { Countdown } = Statistic;
function AntStatistic(props: StatisticProps) {
  return <Statistic {...props} />;
}

function AntCountDown(props: CountDownProps) {
  return <Countdown {...props} />;
}

export { AntStatistic as Statistic, AntCountDown as Countdown };
